import React from 'react';
import ChatMessage from '../../Molecules/Message/ChatMessage';
import { EventCustomerInjectionWrapper } from '../../Service/InjectionWrapper/EventCustomerInjectionWrapper';
import { EventCustomerLoadingWrapper } from './EventCustomerLoadingWrapper';

export default function ({ email, changeEmailById, emailAction, setEmailAction, event, ...rest }) {
  const styles = {
    container: {
      // minHeight: "100%",
      display: 'flex',
      flex: '1 1 auto',
      flexDirection: 'column',
      // alignItems: "stretch",
      // height: "74vh",
      minWidth: 0,
      minHeight: 0,
    },
    messageList: {
      // flexShrink: 0,
      // flexGrow: 1,
      flex: '1 1 auto',
      transform: 'translateZ(0)!important',
      minWidth: 0,
      minHeight: 0,
    },
    editor: {
      flexShrink: 0,
      position: 'sticky',
      left: 0,
      right: 0,
      bottom: 0,
      height: '100%',
    },
  };

  if (!email || emailAction === 'NEW') {
    return null;
  }

  {
    /* if we are in an event, but we're loading an email (cause a participant in on those two events), which is related to another event */
  }
  if (event) {
    if (email.eventId && event.id !== email.eventId) {
      return (
        <EventCustomerLoadingWrapper message={email}>
          <ChatMessage
            id={`email-${email.id}`}
            message={email}
            changeEmailById={changeEmailById}
            setEmailAction={setEmailAction}
            {...rest}
          />
        </EventCustomerLoadingWrapper>
      );
    }
  }

  return (
    <div style={styles.messageList}>
      {window.location.pathname.includes('/events') && (
        <EventCustomerInjectionWrapper>
          <ChatMessage
            id={`email-${email.id}`}
            message={email}
            changeEmailById={changeEmailById}
            setEmailAction={setEmailAction}
            {...rest}
          />
        </EventCustomerInjectionWrapper>
      )}
      {!window.location.pathname.includes('/events') && (
        <EventCustomerLoadingWrapper message={email}>
          <ChatMessage
            id={`email-${email.id}`}
            message={email}
            changeEmailById={changeEmailById}
            setEmailAction={setEmailAction}
            {...rest}
          />
        </EventCustomerLoadingWrapper>
      )}
    </div>
  );
}
